import { render, staticRenderFns } from "./ShowRegisterInfo.vue?vue&type=template&id=bbae8ed0&scoped=true&"
import script from "./ShowRegisterInfo.vue?vue&type=script&lang=js&"
export * from "./ShowRegisterInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbae8ed0",
  null
  
)

export default component.exports